// Shared constants for Deeper Networking site
export const APPLY_URL =
    "https://deepernetworkingapp.integritygo.com/application-page";
export const LOGO_URL =
    "https://customer-assets.emergentagent.com/job_integrity-refresh/artifacts/b828hdpu_dn%20logo.png";
export const HERO_IMG =
    "https://images.unsplash.com/photo-1724866976376-4b217d29a462?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDR8MHwxfHNlYXJjaHwxfHxkaXZlcnNlJTIwcHJvZmVzc2lvbmFscyUyMG5ldHdvcmtpbmclMjBzb3BoaXN0aWNhdGVkJTIwZGFya3xlbnwwfHx8fDE3NzY3OTY0NDJ8MA&ixlib=rb-4.1.0&q=85";
export const ROUNDTABLE_IMG =
    "https://images.pexels.com/photos/8349428/pexels-photo-8349428.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";
export const GOOFBALL_IMG =
    "https://customer-assets.emergentagent.com/job_integrity-refresh/artifacts/y6e4xvl1_Untitled%20design%20%2815%29.png";
